export default () => {
    if (!window.dataLayer)
        return;

    let triggerCustomEvent = function () {
        let bits = ['eventCategory', 'eventAction', 'eventLabel'];
        let values = this.getAttribute('data-event').split(':');
        let tracker = {'event':'eventTracking'};
        for (let i = 0; i < values.length; i++){
            tracker[bits[i]] = values[i];
        }
        dataLayer.push(tracker);
    };

    let customEvents = document.querySelectorAll('[data-event]');
    for (let i = 0; i < customEvents.length; i++) {
        customEvents[i].addEventListener('click', triggerCustomEvent);
    }
};